<!-- <p>user-notice-board works!</p> -->

<!-- <div class="user-notice-board-container">
  <div class="user-notice-board-header">AumYe Community</div>
  <mat-divider></mat-divider>
  <mat-grid-list cols="2" rowHeight="100px" gutterSize="10px">
    <mat-grid-tile
      *ngIf="isPollShared"
      [rowspan]="uploadedAttachment ? 8 : 5"
      [colspan]="screenInfo == ScreenType.Mobile ? 2 : 1"
    >
      <div class="user-notice-board-create-view">
        <div
          [ngClass]="{
            'create-post-card-container':
              screenInfo == ScreenType.Desktop ||
              screenInfo == ScreenType.Tablet,
            'create-post-card-container-mobile': screenInfo == ScreenType.Mobile
          }"
        >
          <mat-card class="post-card">
            <mat-card-header class="post-card-header">
              <div>
                <h3>Create post</h3>
              </div>
            </mat-card-header>
            <mat-card-content>
              <div class="post-card-content">
                <div class="post-card-content-description">
                  <div class="description-header-item">
                    <div class="avatar">
                      <img [src]="loggedIsUsernameProfile" alt="User Avatar" />
                    </div>
                    <div class="user-info">
                      <h5 class="user-name">
                        {{ loggedIsUsername | titlecase }}
                      </h5>
                      <span *ngIf="selectedDate" class="post-time"
                        >Post Validity: <b>{{ selectedDate | date }}</b>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="create-post-card-content">
                  <div class="comment-input" (keydown)="onKeyDown($event)">
                    <div
                      [ngStyle]="
                        isPollShared
                          ? { display: 'flex', 'flex-direction': 'column' }
                          : {}
                      "
                    >
                      <textarea
                        #postTextarea
                        (input)="onCommentInputCheck($event)"
                        placeholder="What's on your mind?"
                        cdkTextareaAutosize
                        cdkAutosizeMinRows="1"
                        [formControl]="createPostControl"
                        cdkAutosizeMaxRows="5"
                        [ngClass]="{ 'with-list': showUserList }"
                        class="custom-textarea"
                      >
                      </textarea>
                      <span *ngIf="isPollShared" class="shared-poll-title">{{
                        pollTitle
                      }}</span>
                    </div>

                    <mat-list *ngIf="showUserList" class="user-list">
                      <mat-list-item
                        *ngFor="let user of filteredUserOrgList; let i = index"
                        (click)="selectUser(user)"
                        [ngClass]="{ active: i === selectedIndex }"
                      >
                        {{ user.firstname + " " + user.lastname }}
                      </mat-list-item>
                    </mat-list>
                  </div>
                </div>
                <div
                  [ngClass]="{
                    'uploaded-attachment-post':
                      screenInfo == ScreenType.Desktop ||
                      screenInfo == ScreenType.Tablet,
                    'uploaded-attachment-post-mobile':
                      screenInfo == ScreenType.Mobile
                  }"
                  (mouseenter)="
                    screenInfo != ScreenType.Mobile
                      ? (showRemoveButton = true)
                      : (showRemoveButton = false)
                  "
                  (mouseleave)="showRemoveButton = false"
                >
                  <div
                    class="remove-button-container"
                    *ngIf="
                      screenInfo == ScreenType.Mobile && uploadedAttachment
                    "
                    (click)="removeImage()"
                  >
                    Remove &nbsp; <mat-icon>cancel</mat-icon>
                  </div>
                  <img [src]="uploadedAttachment" alt="" srcset="" />
                  <div
                    class="remove-button-container"
                    *ngIf="showRemoveButton"
                    (click)="removeImage()"
                  >
                    <mat-icon>cancel</mat-icon>
                  </div>
                </div>
                <div class="post-card-content-actions">
                  <div class="content-action-buttons">
                    <button mat-icon-button (click)="openDatePicker()">
                      <mat-icon>calendar_today</mat-icon>
                      <span>Post Validity</span>
                    </button>
                    <input
                      class="hidden-input"
                      [matDatepicker]="picker"
                      [(ngModel)]="selectedDate"
                      (focus)="picker.open()"
                      [max]="maxDate"
                      [min]="minDate"
                    />
                    <mat-datepicker #picker></mat-datepicker>
                    <button
                      mat-icon-button
                      type="button"
                      (click)="selectFile()"
                    >
                      <span>Upload Image</span>
                      <mat-icon>image</mat-icon>
                    </button>
                    <input
                      type="file"
                      #fileInput
                      style="display: none"
                      accept="image/*"
                      (change)="handleFileChange($event)"
                    />
                  </div>
                  <div class="addons-section-container"></div>
                  <div class="create-post-button">
                    <button
                      [disabled]="
                        !uploadedAttachmentControl.value &&
                        !createPostControl.value
                      "
                      (click)="createPost()"
                      mat-raised-button
                    >
                      Post
                    </button>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </mat-grid-tile>
    <mat-grid-tile
      [colspan]="screenInfo == ScreenType.Mobile ? 2 : 2"
      [rowspan]="isPostReportsOpened ? 6 : 6"
    >
      <app-post-reports
        (isOpened)="onPostReportsOpened($event)"
        [posts]="posts"
        [screenInfo]="screenInfo"
        [loggedIsUsernameProfile]="loggedIsUsernameProfile"
        [currentUserId]="currentUserId"
      >
      </app-post-reports>
    </mat-grid-tile>
    <mat-grid-tile
      [colspan]="screenInfo == ScreenType.Mobile ? 2 : 2"
      rowspan="10"
      ><div class="user-notice-board-content-view">
        <div class="notice-board-card-container">
          <div
            *ngFor="let post of posts; let i = index"
            class="posts-card-container"
            [ngClass]="{
              'posts-card-container': true,
              'zoom-in': i === parentSelectedPostIndex
            }"
          >
            <app-post-card
              [post]="post"
              [userOrgList]="users"
              [loggedIsUsernameProfile]="loggedIsUsernameProfile"
              [currentUserId]="currentUserId"
              [deviceType]="getDeviceType(screenInfo)"
              (onPostComment)="onPostUserComment($event)"
              (onPostLike)="onPostLikeComment($event)"
              (onPostShare)="onPostUserShare($event)"
              (openSharedPostPoll)="onOpenSharedPostPoll($event)"
              (onReportPost)="onReportPostFn($event)"
            ></app-post-card>
          </div>
          <div class="refresh-button">
            <button
              [disabled]="posts.length == 0"
              (click)="refreshNoticeBoard()"
              mat-raised-button
            >
              Refresh
            </button>
          </div>
        </div>
      </div></mat-grid-tile
    >
  </mat-grid-list>
</div> -->
<div
  [ngClass]="{
    'user-notice-board': screenInfo == ScreenType.Desktop,
    'user-notice-board-mobile': screenInfo == ScreenType.Mobile,
    'user-notice-board-Tablet': screenInfo == ScreenType.Tablet
  }"
>
  <div
    class="aumye-community-container max-w-7xl mx-auto px-2 sm:px-4 lg:px-8 py-6"
  >
    <div class="user-notice-board-header">AumYe Community</div>
    <!-- <div class="my-4 flex justify-end" *ngIf="isAdmin">
      <button
        (click)="toggleDashboard()"
        class="px-4 py-2 text-white rounded"
        [ngStyle]="{
          'background-color': '#204f84',
          hover: '#163a63'
        }"
      >
        {{ showDashboard ? "Hide Dashboard" : "Show Dashboard" }}
      </button>
    </div> -->
    <mat-divider></mat-divider>
    <div
      class="aumye-community-main-content grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-6"
    >
      <div
        class="create-post-section"
        *ngIf="isPollShared"
        [ngClass]="{
          'md:col-span-1 lg:col-span-1': screenInfo !== ScreenType.Mobile,
          'col-span-full': screenInfo === ScreenType.Mobile
        }"
      >
        <div class="user-notice-board-create-view">
          <div
            [ngClass]="{
              'bg-white rounded-lg shadow-md p-4': true,
              'w-full': true,
              'max-w-md mx-auto md:max-w-none': screenInfo === ScreenType.Mobile
            }"
          >
            <mat-card class="post-card p-0 shadow-none">
              <mat-card-header
                class="post-card-header pb-4 border-b border-gray-200"
              >
                <div>
                  <h3 class="text-xl font-semibold text-gray-800">
                    Create post
                  </h3>
                </div>
              </mat-card-header>
              <mat-card-content class="pt-4">
                <div class="post-card-content">
                  <div class="post-card-content-description mb-4">
                    <div class="description-header-item flex items-center">
                      <div
                        class="avatar w-10 h-10 rounded-full overflow-hidden mr-3"
                      >
                        <img
                          [src]="loggedIsUsernameProfile"
                          alt="User Avatar"
                          class="w-full h-full object-cover"
                        />
                      </div>
                      <div class="user-info">
                        <h5 class="user-name text-lg font-medium text-gray-900">
                          {{ loggedIsUsername | titlecase }}
                        </h5>
                        <span
                          *ngIf="selectedDate"
                          class="post-time text-sm text-gray-500"
                          >Post Validity:
                          <b class="font-semibold">{{ selectedDate | date }}</b>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="create-post-card-content mb-4">
                    <div
                      class="comment-input relative"
                      (keydown)="onKeyDown($event)"
                    >
                      <div
                        [ngStyle]="
                          isPollShared
                            ? { display: 'flex', 'flex-direction': 'column' }
                            : {}
                        "
                      >
                        <textarea
                          #postTextarea
                          (input)="onCommentInputCheck($event)"
                          placeholder="What's on your mind?"
                          cdkTextareaAutosize
                          cdkAutosizeMinRows="1"
                          [formControl]="createPostControl"
                          cdkAutosizeMaxRows="5"
                          [ngClass]="{ 'ring-2 ring-blue-500': showUserList }"
                          class="custom-textarea w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none overflow-hidden text-gray-700"
                        >
                        </textarea>
                        <span
                          *ngIf="isPollShared"
                          class="shared-poll-title text-sm text-gray-600 mt-2 block"
                          >{{ pollTitle }}</span
                        >
                      </div>

                      <mat-list
                        *ngIf="showUserList"
                        class="user-list absolute z-10 bg-white border border-gray-300 rounded-lg shadow-lg mt-1 w-full max-h-48 overflow-y-auto"
                      >
                        <mat-list-item
                          *ngFor="
                            let user of filteredUserOrgList;
                            let i = index
                          "
                          (click)="selectUser(user)"
                          [ngClass]="{ 'bg-blue-100': i === selectedIndex }"
                          class="px-4 py-2 cursor-pointer hover:bg-gray-100 text-gray-800"
                        >
                          {{ user.firstname + " " + user.lastname }}
                        </mat-list-item>
                      </mat-list>
                    </div>
                  </div>

                  <div
                    *ngIf="uploadedAttachment"
                    [ngClass]="{
                      'relative rounded-lg overflow-hidden mb-4': true,
                      'border border-gray-300': true,
                      'h-48':
                        screenInfo === ScreenType.Desktop ||
                        screenInfo === ScreenType.Tablet,
                      'h-auto max-h-60': screenInfo === ScreenType.Mobile
                    }"
                    (mouseenter)="
                      screenInfo !== ScreenType.Mobile
                        ? (showRemoveButton = true)
                        : (showRemoveButton = false)
                    "
                    (mouseleave)="showRemoveButton = false"
                  >
                    <div
                      class="remove-button-container absolute top-2 right-2 bg-red-500 text-white px-3 py-1 rounded-full text-sm flex items-center cursor-pointer opacity-90 hover:opacity-100 transition-opacity"
                      *ngIf="
                        screenInfo === ScreenType.Mobile && uploadedAttachment
                      "
                      (click)="removeImage()"
                    >
                      Remove &nbsp;
                      <mat-icon class="text-base">cancel</mat-icon>
                    </div>
                    <img
                      [src]="uploadedAttachment"
                      alt=""
                      srcset=""
                      class="w-full h-full object-contain"
                    />
                    <div
                      class="remove-button-container absolute top-2 right-2 bg-red-500 text-white p-2 rounded-full cursor-pointer opacity-0 group-hover:opacity-100 transition-opacity"
                      *ngIf="
                        showRemoveButton && screenInfo !== ScreenType.Mobile
                      "
                      (click)="removeImage()"
                    >
                      <mat-icon class="text-lg">cancel</mat-icon>
                    </div>
                  </div>

                  <div
                    class="post-card-content-actions flex flex-col sm:flex-row sm:justify-between sm:items-center"
                  >
                    <div
                      class="content-action-buttons flex flex-wrap gap-x-4 gap-y-2 mb-4 sm:mb-0"
                    >
                      <button
                        mat-icon-button
                        (click)="openDatePicker()"
                        class="flex items-center text-blue-600 hover:text-blue-800 transition-colors"
                      >
                        <mat-icon class="mr-1">calendar_today</mat-icon>
                        <span>Post Validity</span>
                      </button>
                      <input
                        class="hidden-input"
                        [matDatepicker]="picker"
                        [(ngModel)]="selectedDate"
                        (focus)="picker.open()"
                        [max]="maxDate"
                        [min]="minDate"
                      />
                      <mat-datepicker #picker></mat-datepicker>
                      <button
                        mat-icon-button
                        type="button"
                        (click)="selectFile()"
                        class="flex items-center text-blue-600 hover:text-blue-800 transition-colors"
                      >
                        <span>Upload Image</span>
                        <mat-icon class="ml-1">image</mat-icon>
                      </button>
                      <input
                        type="file"
                        #fileInput
                        class="hidden"
                        accept="image/*"
                        (change)="handleFileChange($event)"
                      />
                    </div>
                    <div class="addons-section-container"></div>
                    <div class="create-post-button">
                      <button
                        [disabled]="
                          !uploadedAttachmentControl.value &&
                          !createPostControl.value
                        "
                        (click)="createPost()"
                        mat-raised-button
                        class="w-full sm:w-auto px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        Post
                      </button>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </div>

      <div
        *ngIf="showDashboard"
        class="post-reports-section"
        [ngClass]="{
          'md:col-span-1 lg:col-span-1': screenInfo !== ScreenType.Mobile,
          'col-span-full': screenInfo === ScreenType.Mobile
        }"
      >
        <app-post-reports
          (isOpened)="onPostReportsOpened($event)"
          (postActionTaken)="onPostActionTaken($event)"
          (postFlaggedpostAction)="onPostFlaggedpostAction($event)"
          [orgPosts]="posts"
          [users]="users"
          [screenInfo]="screenInfo"
          [loggedIsUsernameProfile]="loggedIsUsernameProfile"
          [currentUserId]="currentUserId"
        >
        </app-post-reports>
      </div>
      <mat-divider></mat-divider>

      <div
        class="user-notice-board-content-view lg:col-span-1 md:col-span-2 col-span-full"
      >
        <div class="notice-board-card-container">
          <div
            *ngFor="let post of posts; let i = index"
            class="posts-card-container mb-6 bg-white rounded-lg shadow-md overflow-hidden"
            [attr.id]="'post-' + post.postId"
          >
            <app-post-card
              [post]="post"
              [highlightedPostId]="postIdFromRoute"
              [userOrgList]="users"
              [loggedIsUsernameProfile]="loggedIsUsernameProfile"
              [currentUserId]="currentUserId"
              [deviceType]="getDeviceType(screenInfo)"
              (onPostComment)="onPostUserComment($event)"
              (onPostLike)="onPostLikeComment($event)"
              (onPostShare)="onPostUserShare($event)"
              (openSharedPostPoll)="onOpenSharedPostPoll($event)"
              (onReportPost)="onReportPostFn($event)"
            ></app-post-card>
          </div>
          <div class="refresh-button text-center mt-8">
            <button
              [disabled]="posts.length == 0"
              (click)="refreshNoticeBoard()"
              mat-raised-button
              class="px-8 py-3 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Refresh
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<br />
<br />
<br />
